import React, { useState } from "react";
import { Wrapper } from "./ExpensesTables.styled";
import { Table, Button, Modal } from "components/common";
import { columns, data } from "./dummyData";
import AddExpenses from "./AddExpenses";
import { getUserPermissions } from "utils/text";
const ExpensesTable = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Wrapper>
      <Table
        columns={columns}
        dataSource={props.expensesData}
        header
        loading={props.isLoading}
        pagination={true}
        headerTitle="Manage Expenses"
        button
        button2={
          getUserPermissions("delete-expense-action") && (
            <Button title="Delete" MinusIcon className="deleteButton" />
          )
        }
        button1={
          getUserPermissions("add-expense-action") && (
            <Button
              title="Add New Expense"
              AddIcon
              className="addButton"
              onClick={() => setIsOpen(true)}
            />
          )
        }
      />
      <Modal
        isOpen={isOpen}
        title="Add Expense"
        toggleModal={() => setIsOpen(false)}
        onOk={() => {
          if (props.formData.projectId !== "") {
            props.callPostApi();
            setIsOpen(false);
          }
        }}
      >
        <AddExpenses
          formData={props.formData}
          setFormData={props.setFormData}
          callPostApi={props.callPostApi}
        />
      </Modal>
    </Wrapper>
  );
};

export default ExpensesTable;
